module.exports = __webpack_public_path__ + "static/media/9DESA13.b11d687d.jpg";